import React from 'react'

import Anchor from '@/components/anchor/anchor'
import Button from '@/components/button/button'
import Image from '@/components/image/image'
import StructuredTextDefault from '@/components/structured-text/structured-text-default'
import { anchorFormatted } from '@/utils/format'

import * as style from './highlights-section.module.scss'

type HighligthsSectionProps = Queries.DatoCmsHighlightsSection

const HighligthsSection = ({
  bannerCta,
  bannerImage,
  bannerTitle,
  title,
  highlights
}: HighligthsSectionProps) => {
  const thisCTA = bannerCta && bannerCta?.length > 0 ? bannerCta?.[0] : null

  return (
    <section>
      <Anchor anchor={anchorFormatted(title)} />
      <div className={`container ${style.section}`}>
        <div className="row">
          {highlights.map((highlight) => {
            return (
              <>
                <div className={`col-12 col-md-5 col-xl-6`}>
                  <div className={style.wrapperImage}>
                    <Image image={highlight?.image} className={style.image} />
                  </div>
                </div>
                <div
                  className={`col-12 offset-md-1 col-md-6 offset-xl-1 col-xl-5 ${style.wrapperContent}`}
                >
                  <p
                    className={`b100 text-base-000 ${style.preTitle} my-0 text-uppercase`}
                  >
                    {highlight?.preTitle}
                  </p>
                  <h3 className="h300 text-brand-primary">
                    {highlight?.title}
                  </h3>

                  <StructuredTextDefault
                    content={highlight?.content}
                    className="text-base-000 b100"
                  />
                </div>
              </>
            )
          })}
        </div>
      </div>
      <div className={style.wrapperBanner}>
        <Image image={bannerImage} className={style.imageBanner} />
        <div className={`${style.container} container`}>
          <div className={`${style.content} bg-base-000`}>
            <h3 className={`${style.titleBanner} h100 text-base-1000`}>
              {bannerTitle}
            </h3>
            {thisCTA && (
              <Button
                className={`${style.button}`}
                title={thisCTA.text}
                to={thisCTA.link}
                color="custom"
              />
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

export default HighligthsSection
